(function() {
  const root = document.querySelector('.cscfg');
  if (!root) return;

  const animEls = root.querySelectorAll('.cscfg-anim');
  if (animEls.length > 0 && typeof IntersectionObserver !== 'undefined') {
    const animIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('cscfg-visible');
          animIo.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    animEls.forEach(function(el) { animIo.observe(el); });
    setTimeout(function() {
      animEls.forEach(function(el) {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('cscfg-visible');
      });
    }, 800);
  } else {
    animEls.forEach(function(el) { el.classList.add('cscfg-visible'); });
  }

  const state = {
    heading: 'Works well with',
    discount: 10,
    badge_text: 'OFF',
    badge_bg_color: '#B71C1C',
    badge_text_color: '#FFFFFF',
    item_bg_color: 'rgba(255,255,255,0.03)',
    item_border_color: 'rgba(255,255,255,0.1)',
    title_color: '#FFFFFF',
    price_color: '#FFFFFF',
    sale_price_color: '#F35D9C',
    button_bg_color: '#F35D9C',
    button_icon_color: '#FFFFFF',
    display_type: 'stacked',
    max_products: 4
  };

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return root.querySelectorAll(sel); }

  const csWrap = $('#cscfgCs');
  const csItems = $('#cscfgCsItems');

  function formatPrice(n) {
    return '£' + n.toFixed(2);
  }

  function render() {
    const headingEl = $('#cscfgCsHeading');
    if (headingEl) headingEl.textContent = state.heading;

    if (csWrap) csWrap.dataset.display = state.display_type;

    csWrap.style.setProperty('--cs-badge-bg', state.badge_bg_color);
    csWrap.style.setProperty('--cs-badge-text', state.badge_text_color);
    csWrap.style.setProperty('--cs-item-bg', state.item_bg_color);
    csWrap.style.setProperty('--cs-item-border', state.item_border_color);
    csWrap.style.setProperty('--cs-title', state.title_color);
    csWrap.style.setProperty('--cs-price', state.price_color);
    csWrap.style.setProperty('--cs-sale-price', state.sale_price_color);
    csWrap.style.setProperty('--cs-btn-bg', state.button_bg_color);
    csWrap.style.setProperty('--cs-btn-icon', state.button_icon_color);

    const items = $$('[data-cs-item]');
    items.forEach(function(item, idx) {
      if (idx < state.max_products) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }

      const base = parseFloat(item.dataset.base);
      const sale = base * (1 - state.discount / 100);
      const saleEl = item.querySelector('[data-cs-price-sale]');
      const wasEl = item.querySelector('[data-cs-price-was]');
      const badgeEl = item.querySelector('[data-cs-badge]');

      if (state.discount > 0) {
        if (saleEl) {
          saleEl.textContent = formatPrice(sale);
          saleEl.style.display = '';
        }
        if (wasEl) {
          wasEl.textContent = formatPrice(base);
          wasEl.style.display = '';
        }
        if (badgeEl) {
          badgeEl.textContent = '-' + state.discount + '% ' + state.badge_text;
          badgeEl.style.display = '';
        }
      } else {
        if (saleEl) {
          saleEl.textContent = formatPrice(base);
        }
        if (wasEl) {
          wasEl.style.display = 'none';
        }
        if (badgeEl) {
          badgeEl.style.display = 'none';
        }
      }
    });

    $$('[data-swatches]').forEach(function(group) {
      const key = group.dataset.swatches;
      const val = state[key];
      group.querySelectorAll('.cscfg__sw').forEach(function(sw) {
        sw.classList.toggle('is-on', sw.dataset.color && sw.dataset.color.toLowerCase() === (val || '').toLowerCase());
      });
    });

    $$('[data-color-pip]').forEach(function(pip) {
      const key = pip.dataset.colorPip;
      const val = state[key] || '';
      pip.style.background = val;
    });

    $$('[data-color-input]').forEach(function(input) {
      const key = input.dataset.colorInput;
      if (document.activeElement !== input) {
        const val = state[key] || '';
        input.value = val.startsWith('#') ? val.toUpperCase() : val;
      }
    });

    $$('[data-cscfg-seg]').forEach(function(group) {
      const key = group.dataset.cscfgSeg;
      const val = state[key];
      group.querySelectorAll('.cscfg__seg-btn').forEach(function(btn) {
        btn.classList.toggle('is-on', btn.dataset.val === val);
      });
    });
  }

  $$('[data-cscfg-input]').forEach(function(input) {
    input.addEventListener('input', function() {
      state[input.dataset.cscfgInput] = input.value;
      render();
    });
  });

  $$('[data-cscfg-seg] .cscfg__seg-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const group = btn.closest('[data-cscfg-seg]');
      state[group.dataset.cscfgSeg] = btn.dataset.val;
      render();
    });
  });

  $$('.cscfg__sw[data-color]').forEach(function(sw) {
    sw.addEventListener('click', function() {
      const group = sw.closest('[data-swatches]');
      state[group.dataset.swatches] = sw.dataset.color;
      render();
    });
  });

  $$('[data-color-input]').forEach(function(input) {
    input.addEventListener('input', function() {
      const key = input.dataset.colorInput;
      let val = input.value.trim();
      if (val.startsWith('rgba') || val.startsWith('rgb')) {
        state[key] = val;
        render();
        return;
      }
      if (!val.startsWith('#')) val = '#' + val;
      if (/^#[0-9A-Fa-f]{6}$/.test(val) || /^#[0-9A-Fa-f]{3}$/.test(val)) {
        state[key] = val;
        render();
      }
    });
  });

  $$('[data-slider]').forEach(function(slider) {
    const key = slider.dataset.slider;
    const min = parseInt(slider.dataset.min);
    const max = parseInt(slider.dataset.max);
    const step = parseInt(slider.dataset.step) || 1;
    const fill = slider.querySelector('.cscfg__slider-fill');
    const knob = slider.querySelector('.cscfg__slider-knob');
    const valEl = root.querySelector('[data-slider-val="' + key + '"]');

    function setFromValue(val) {
      val = Math.max(min, Math.min(max, val));
      val = Math.round(val / step) * step;
      state[key] = val;
      const pct = ((val - min) / (max - min)) * 100;
      fill.style.width = pct + '%';
      knob.style.left = pct + '%';
      if (valEl) valEl.value = val;
      render();
    }

    function setFromX(clientX) {
      const rect = slider.getBoundingClientRect();
      const pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      setFromValue(min + pct * (max - min));
    }

    let dragging = false;
    slider.addEventListener('mousedown', function(e) {
      dragging = true;
      setFromX(e.clientX);
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e) { if (dragging) setFromX(e.clientX); });
    document.addEventListener('mouseup', function() { dragging = false; });
    slider.addEventListener('touchstart', function(e) { dragging = true; setFromX(e.touches[0].clientX); }, { passive: true });
    document.addEventListener('touchmove', function(e) { if (dragging) setFromX(e.touches[0].clientX); }, { passive: true });
    document.addEventListener('touchend', function() { dragging = false; });
  });

  const navBtns = root.querySelectorAll('#cscfgCsNav .cscfg__cs-nav-btn');
  if (navBtns.length === 2 && csItems) {
    navBtns[0].addEventListener('click', function() {
      csItems.scrollBy({ left: -csItems.clientWidth, behavior: 'smooth' });
    });
    navBtns[1].addEventListener('click', function() {
      csItems.scrollBy({ left: csItems.clientWidth, behavior: 'smooth' });
    });
  }

  const cart = $('#cscfgCart');
  const cartBody = $('#cscfgCartBody');
  const cartCount = $('#cscfgCartCount');
  const cartSub = $('#cscfgCartSub');
  const cartCloseBtns = root.querySelectorAll('[data-cscfg-cart-close]');

  const mainProduct = {
    name: 'Pink Daisy Playsuit',
    price: 25.00,
    bg: '#F3A8C0'
  };

  let cartLines = [];

  function renderCart() {
    if (!cartBody) return;
    if (cartLines.length === 0) {
      cartBody.innerHTML = '<div class="cscfg__cart-empty">Your cart is empty</div>';
      cartCount.textContent = '0';
      cartSub.textContent = '£0.00';
      return;
    }
    cartBody.innerHTML = cartLines.map(function(l) {
      const lineSale = l.price * l.qty;
      const lineCompare = (l.compareAt || 0) * l.qty;
      const hasDiscount = l.compareAt && l.compareAt > l.price;
      const priceHtml = hasDiscount
        ? '<span class="cscfg__cart-line-pr-sale">£' + lineSale.toFixed(2) + '</span>' +
          '<span class="cscfg__cart-line-pr-was">£' + lineCompare.toFixed(2) + '</span>'
        : '<span class="cscfg__cart-line-pr-sale cscfg__cart-line-pr-sale--plain">£' + lineSale.toFixed(2) + '</span>';
      return '<div class="cscfg__cart-line">' +
        '<div class="cscfg__cart-line-img" style="background:' + l.bg + '"></div>' +
        '<div class="cscfg__cart-line-info">' +
          '<div class="cscfg__cart-line-name">' + l.name + '</div>' +
          '<div class="cscfg__cart-line-qty">Qty ' + l.qty + '</div>' +
        '</div>' +
        '<div class="cscfg__cart-line-pr">' + priceHtml + '</div>' +
      '</div>';
    }).join('');
    const totalQty = cartLines.reduce(function(s, l) { return s + l.qty; }, 0);
    const totalPrice = cartLines.reduce(function(s, l) { return s + (l.price * l.qty); }, 0);
    const totalCompare = cartLines.reduce(function(s, l) { return s + ((l.compareAt || l.price) * l.qty); }, 0);
    cartCount.textContent = totalQty;
    if (totalCompare > totalPrice) {
      cartSub.innerHTML = '<span class="cscfg__cart-sub-was">£' + totalCompare.toFixed(2) + '</span> £' + totalPrice.toFixed(2);
    } else {
      cartSub.textContent = '£' + totalPrice.toFixed(2);
    }
  }

  function addToCart(product) {
    const existing = cartLines.find(function(l) { return l.name === product.name; });
    if (existing) {
      existing.qty += 1;
    } else {
      cartLines.push(Object.assign({ qty: 1 }, product));
    }
    renderCart();
  }

  function openCart() {
    if (cart) cart.classList.add('is-open');
  }

  function closeCart() {
    if (cart) cart.classList.remove('is-open');
  }

  cartCloseBtns.forEach(function(btn) {
    btn.addEventListener('click', closeCart);
  });

  $$('.cscfg__cs-item').forEach(function(item) {
    const addBtn = item.querySelector('.cscfg__cs-add');
    if (!addBtn) return;
    addBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (!cartLines.find(function(l) { return l.name === mainProduct.name; })) {
        cartLines.push(Object.assign({ qty: 1 }, mainProduct));
      }

      const name = item.dataset.name;
      const base = parseFloat(item.dataset.base);
      const sale = base * (1 - state.discount / 100);
      const bg = item.querySelector('.cscfg__cs-img').style.background || '#F3A8C0';

      addToCart({
        name: name,
        price: state.discount > 0 ? sale : base,
        compareAt: state.discount > 0 ? base : null,
        bg: bg
      });

      openCart();
    });
  });

  const pdpAtc = root.querySelector('.cscfg__pdp-atc');
  if (pdpAtc) {
    pdpAtc.addEventListener('click', function() {
      addToCart(mainProduct);
      openCart();
    });
  }

  renderCart();

  const grid = $('#cscfgGrid');
  const seeLiveBtn = $('#cscfgSeeLive');
  if (seeLiveBtn && grid) {
    seeLiveBtn.addEventListener('click', function() {
      const isPreview = grid.classList.toggle('is-preview');
      seeLiveBtn.classList.toggle('is-back', isPreview);
      if (isPreview) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  render();
})();

(function() {
  var sections = document.querySelectorAll('.cscfg');
  if (!sections.length) return;
  var headerHideObserver = new IntersectionObserver(function(entries) {
    var anyVisible = entries.some(function(e) { return e.isIntersecting; });
    if (anyVisible) {
      document.body.classList.add('cscfg-section-active');
    } else {
      var stillVisible = false;
      sections.forEach(function(el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.5 && r.bottom > 80) stillVisible = true;
      });
      if (!stillVisible) document.body.classList.remove('cscfg-section-active');
    }
  }, { threshold: 0, rootMargin: '-80px 0px -50% 0px' });
  sections.forEach(function(sec) { headerHideObserver.observe(sec); });
})();